import { Container } from "@chakra-ui/react";
import React from "react";

const EmployerQuestions = () => {
  return (
    <Container>
      Please help answer these questions about your employer
    </Container>
  );
};

export default EmployerQuestions;
